import React from 'react';
import { Helmet } from 'react-helmet';

import LoginFormContainerSSO from './LoginFormContainerSSO';
import useScript from '../../../../../shared/hooks/useScript';
import BackgroundSlidesPageContainer from '../../shared/BackgroundSlidesPageContainer';
import PageWrapper from '../../shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from '../../hooks/useBackgroundSlides';
import useAuthCheck from '../../hooks/useAuthCheck';

const slides = createLoginSlides(12);

const LoginWithSSOToken = () => {
  useAuthCheck();
  const { imageTransition } = useBackgroundSlides(slides);

  useScript('https://cdn.ywxi.net/js/1.js');

  return (
    <BackgroundSlidesPageContainer
      imageTransition={imageTransition}
    >
      <Helmet>
        <title>Sign In | TeamBuildr</title>
      </Helmet>
      <PageWrapper>
        <LoginFormContainerSSO />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default LoginWithSSOToken;
